export default __webpack_public_path__ + "static/media/experience.b05539b8.svg";